import React, { useMemo } from "react";
import {
  TableRow,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  TableCell,
} from "@mui/material";
import { connect } from "react-redux";
import InsuranceTypeList from "@instream-solutions/instream-design-system/lib/Data/InsuranceTypeList";

import TextInput from "./TextInput";
import { DeleteOutline as DeleteIcon } from "@mui/icons-material";

const DropDown = ({
  id,
  label,
  value,
  className = "",
  onChange,
  options,
  error,
}) => {
  return (
    <FormControl
      variant="outlined"
      className={className}
      sx={{ m: 1, minWidth: 160 }}
      error={error}
    >
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select labelId={`${id}-label`} id={id} value={value} onChange={onChange}>
        {options.map((item) => (
          <MenuItem value={item.key}>{item.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const InsuranceCard = ({
  onDelete,
  onUpdate,
  canDelete,
  currentClient,
  insurance,
}) => {
  const clientInformation = useMemo(() => currentClient.toJS(), [
    currentClient,
  ]);

  const appliesToListItems = useMemo(() => {
    const list = [
      {
        key: clientInformation.client.id,
        name: `${clientInformation.client.firstName} ${clientInformation.client.lastName}`,
      },
    ];

    if (clientInformation.coClient.id !== undefined) {
      list.push({
        key: clientInformation.coClient.id,
        name: `${clientInformation.coClient.firstName} ${clientInformation.coClient.lastName}`,
      });
    }

    return list;
  }, [currentClient]);

  const policyTypeListItems = useMemo(() => {
    return InsuranceTypeList();
  }, []);

  const convertToNumber = (value) => {
    const number = Number(value);
    if (isNaN(number)) return 0;
    return value;
  };

  return (
    <TableRow className="insurance-card">
      <TableCell>
        <DropDown
          id={"input-owner-type"}
          label={""}
          options={appliesToListItems}
          value={insurance.appliesTo}
          onChange={(e) => onUpdate("appliesTo")(e.target.value)}
          error={insurance.appliesTo === null}
          helperText="Select an Owner"
        />
      </TableCell>
      <TableCell>
        <DropDown
          id={"input-policy-type"}
          label={""}
          options={policyTypeListItems}
          value={insurance.policyType}
          onChange={(e) => onUpdate("policyType")(e.target.value)}
          error={insurance.policyType === null}
          helperText="Select a Policy Type"
        />
      </TableCell>
      <TableCell>
        <TextInput
          id="input-death-benefits-value"
          type="number"
          label=""
          value={insurance.deathBenefit}
          adornment="$"
          onChange={(e) =>
            onUpdate("deathBenefit")(convertToNumber(e.target.value))
          }
          helperText="Must be greater than $0"
        />
      </TableCell>
      <TableCell>
        <TextInput
          id="input-cash-value"
          type="number"
          label=""
          value={insurance.cashValue}
          adornment="$"
          onChange={(e) =>
            onUpdate("cashValue")(convertToNumber(e.target.value))
          }
        />
      </TableCell>
      <TableCell>
        {canDelete && (
          <IconButton
            className="delete-insurance-btn"
            aria-label="delete"
            onClick={() => onDelete(insurance)}
            size="large">
            <DeleteIcon />
          </IconButton>
        )}
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUserReducer,
    currentClient: state.currentClientReducer,
  };
};

export default connect(mapStateToProps)(InsuranceCard);
